const NewsPage = () => {
  return <div>News</div>
}

export default NewsPage
